// extracted by mini-css-extract-plugin
module.exports = {"terms-of-service":"TermsOfService_terms-of-service__2G46E"};